<template>
  <div>
    <el-card shadow="always">
      <el-page-header @back="back()" title content="Meu Cadastro"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" ref="ruleForm" label-position="top">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6" :md="6" :lg="4" :xl="4">
            <el-form-item :label="$t('nome-fantasia')" prop="name">
              <el-input ref="name" v-model="ruleForm.name" disabled maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="18" :md="18" :lg="10" :xl="10" v-if="ruleForm.partner">
            <el-form-item :label="$t('parceiro-negocio')" prop="partner">
              <el-input ref="partner" v-model="ruleForm.partner" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item :label="$t('cpf/cnpj')" prop="federalid" class="is-required">
              <el-input v-model="ruleForm.federalid" v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="18" :md="18" :lg="10" :xl="10">
            <el-form-item :label="$t('razao-social')" prop="companyname">
              <el-input ref="companyname" v-model="ruleForm.companyname" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8">
            <el-form-item :label="$t('tipo-faturamento')" prop="financial">
              <el-input ref="name" v-model="ruleForm.financial" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8">
            <el-form-item :label="$t('tabela-pacote')" prop="packagetable">
              <el-input ref="name" v-model="ruleForm.packagetable" disabled maxlength="40"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('nome-contato')" prop="contact">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <el-input v-model="ruleForm.contact" maxlength="80"></el-input>
          </el-col>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="10" :md="10" :lg="5" :xl="8">
            <el-form-item label="E-mail Financeiro" prop="mail">
              <el-input ref="mail" v-model="ruleForm.mail" maxlength="80"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('cep')" prop="cep">
              <el-input maxlength="9" v-model="ruleForm.cep" v-mask="'#####-###'" @blur="zipcode()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('endereco')" prop="address">
              <el-input v-model="ruleForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('bairro')" prop="neighborhood">
              <el-input v-model="ruleForm.neighborhood"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('cidade')" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6" :lg="2" :xl="3">
            <el-form-item :label="$t('estado')" prop="state">
              <el-input v-model="ruleForm.state"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('numero')" prop="number">
              <el-input type="number" maxlength="6" v-model="ruleForm.number" v-mask="'######'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('complemento')" prop="extent">
              <el-input v-model="ruleForm.extent" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="10" :md="10" :lg="5" :xl="8">
            <el-form-item :label="$t('inscricao-estadual')" prop="cep">
              <el-input maxlength="20" v-model="ruleForm.registerstate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="10" :md="10" :lg="5" :xl="8">
            <el-form-item :label="$t('inscricao-municipal')" prop="cep">
              <el-input maxlength="20" v-model="ruleForm.registermunicipal"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('site')" prop="site">
          <el-input v-model="ruleForm.site" maxlength="155">
            <template slot="prepend">http://</template>
          </el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('telefone-comercial')" prop="cep">
              <el-input maxlength="16" v-model="ruleForm.commercial" v-mask="'(##) ####-####'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('telefone-residencial')" prop="cep">
              <el-input maxlength="16" v-model="ruleForm.residential" v-mask="'(##) ####-####'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('telefone-celular')" prop="cep">
              <el-input maxlength="16" v-model="ruleForm.cellphone"
                v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">Notificar Meus Clientes</el-divider>
        <el-row :gutter="5">
          <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
            <el-form-item prop="whatsapp">
              <el-checkbox ref="whatsapp" v-model="ruleForm.whatsapp">{{ $t('whatsapp') }}</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :xs="9">
            <el-alert :closable="false">Ao informar um telefone na criação de uma postagem a MaisEnvios irá enviar
              notificações para o seu
              cliente informando a movimentação do rastreio</el-alert>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{ $t("salvar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { CustomerService } from "@/services/customers/customers.services";

import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../mixins/zipcode";

export default {
  name: "CustomerAdd",
  mixins: [ZipMixins],
  data() {
    return {
      activeTab: "billet",
      ruleForm: {
        name: "",
        companyname: "",
        financial: "",
        federalid: "",
        registermunicipal: "",
        registerstate: "",
        mail: "",
        cep: "",
        address: "",
        contact: "",
        city: "",
        state: "",
        whatsapp: true,
        neighborhood: "",
        number: "",
        packagetable: "",
        site: "",
        extent: "",
        commercial: "",
        residential: "",
        cellphone: "",
        services: [],
        partner: "",
        notification: {
          prepost: true,
          plp: true,
          collected: true,
          post: true,
          traffic: true,
          out: true,
          delivered: true,
          requestinfo: true,
        }
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "home" });
    },
    submitForm(formName) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.save(vm.ruleForm)
        .then((response) => {
          this.$message({
            type: "success",
            message: i18n.tc("dados-atualizados-sucesso"),
            duration: 5000,
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    CustomerService.me()
      .then((response) => {
        vm.ruleForm = response;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>

